import { Button, Grid, IconButton } from "@material-ui/core";
import { FieldArray } from "formik";
import React from "react";
import InputField from "src/components/ui-components/InputField";
import DeleteIcon from "@material-ui/icons/Delete";
import { AddCircle } from "@material-ui/icons";
import SelectField from "src/components/ui-components/SelectField";

function Query({ value, formRef, isLoading, fieldDataTypeMaster, fieldDataTypeFormatMaster }) {
  return (
    <>
      {value === 1 && (
        <Grid spacing={2} container sx={{ paddingTop: "20px" }}>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
            <InputField label="Parameter Separator" name="parameterSeparator" />
          </Grid>
          <Grid item xs={12} sm={6} md={6} lg={6} xl={6}></Grid>
          <FieldArray name="webMethodsRequestParams">
            {({ remove, push }) => (
              <>
                {formRef.current.values.webMethodsRequestParams?.map(
                  (field, index) => (
                    <React.Fragment key={index}>
                      <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                        <InputField
                          label="Parameter Key *"
                          name={`webMethodsRequestParams.${index}.parameterKey`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
                        <InputField
                          label="Parameter Value"
                          name={`webMethodsRequestParams.${index}.parameterValue`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                        <SelectField
                          label={`Field Type`}
                          name={`webMethodsRequestParams.${index}.fieldType`}
                          data={fieldDataTypeMaster}
                          dataTextField="fieldType"
                          dataValueField="fieldDataTypeMasterKey"
                          onChange={(event) => {
                            const selectedFieldKey = event?.fieldDataTypeMasterKey ?? null;
                            formRef?.current?.setFieldValue(`webMethodsRequestParams.${index}.fieldType`, selectedFieldKey);
                            formRef?.current?.setFieldValue(`webMethodsRequestParams.${index}.format`, null);
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={2} md={2} lg={2} xl={2}>
                        <SelectField
                          label={`Format`}
                          name={`webMethodsRequestParams.${index}.format`}
                          data={fieldDataTypeFormatMaster.filter(
                            (x) => x.fieldDataTypeMasterKey === formRef?.current?.values.webMethodsRequestParams[index]?.fieldType
                          ) || []}
                          dataTextField="format"
                          dataValueField="formatMasterKey"
                        />
                      </Grid>
                      <Grid item xs={2} sm={2} md={2} lg={2} xl={2} sx={{mt:1}}>
                        {formRef.current.values.webMethodsRequestParams
                          .length > 1 && (
                            <IconButton
                              sx={{ p: "10px" }}
                              onClick={() => remove(index)}
                            >
                              <DeleteIcon fontSize="medium" />
                            </IconButton>
                          )}
                        {index ===
                          formRef.current.values.webMethodsRequestParams
                            .length -
                          1 && (
                            <Button
                              sx={{
                                background:
                                  "linear-gradient(to bottom, #072f40, #072f40)",
                                minWidth: 100,
                              }}
                              type="button"
                              size="small"
                              variant="contained"
                              startIcon={<AddCircle />}
                              onClick={() => {
                                push({ parameterKey: "", parameterValue: "" });
                              }}
                              disabled={
                                formRef?.current?.values?.webMethodsRequestParams?.some(
                                  (x) => !x.parameterKey
                                ) || isLoading
                              }
                            >
                              Add
                            </Button>
                          )}
                      </Grid>
                    </React.Fragment>
                  )
                )}
              </>
            )}
          </FieldArray>
        </Grid>
      )}
    </>
  );
}

export default Query;
